/**
 * Styled Components - Created by david on 17/04/18.
 */
import styled from 'styled-components'
import AntdInput from 'antd/lib/input'
import AntdButton, { ButtonProps as AntdButtonProps } from 'antd/lib/button'
import {
  WHITE_SMOKE,
  BLUE,
  WHITE,
  GRAY_SOFT,
  BLACK,
} from '../../../theme/colors'

export const Container = styled.div`
  height: 100%;
  overflow-y: scroll;
`

const { TextArea } = AntdInput
export const Input = styled(TextArea)`
  border-radius: 0px;
  height: 32px;
`

export const InputWrapper = styled.div`
  padding: 12px 32px;

  .ant-input-group-addon {
    background-color: ${({ disabled }: ButtonProps) =>
      disabled ? WHITE_SMOKE : BLUE};
    border: 0px;
  }

  .ant-input:hover {
    border-color: ${BLUE};
  }

  .ant-input:focus {
    border-color: ${BLUE};
    -webkit-box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
    outline: 0;
  }

  .ant-input::selection {
    background: ${BLUE};
  }

  @media (min-width: 768px) and (max-width: 991px) {
    padding: 12px 10px 0px;
  }
`

export const ArrowIcon = styled.img`
  padding-right: 8px;
`

export const Header = styled.div`
  padding: 6px 30px;
  display: flex;
  flex-direction: column;
  row-gap: 6px;
  justify-content: space-between;
  min-height: 55px;
`

interface ButtonProps {
  disabled: boolean
}

export const Button = styled(AntdButton as React.ComponentClass<
  AntdButtonProps
>)`
  color: ${({ disabled }: ButtonProps) => (disabled ? GRAY_SOFT : WHITE)};
  cursor: ${({ disabled }: ButtonProps) =>
    disabled ? 'not-allowed' : 'pointer'};
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
  user-select: none;
  background-color: ${BLACK};
  height: 40px;
  border-radius: 22px;
  padding: 0 32px;
  &.ant-btn-clicked,
  &.ant-btn-clicked::after,
  &:active,
  &:focus,
  &:hover {
    background: ${WHITE};
    color: ${BLACK};
    border-color: ${BLACK};
  }
  &::after {
    border-color: ${BLACK};
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 10px;
  justify-content: flex-end;
`

export const RowOptions = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0px 32px;
  margin-right: 0px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/TextTab/styledComponents.tsx